var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.singleDiscovery).length)?_c('DiscoveryTableSingleComponents',{attrs:{"edit-mode":true,"single-discovery":_vm.singleDiscovery}}):_c('PreloaderComponent')}
var staticRenderFns = []

export { render, staticRenderFns }